import { Lender } from '@1delta/lender-registry'
import { getCompoundV3Assets } from '../../../assets'
import {
  getCompoundV3BaseAsset,
  getCompoundV3CometAddress,
  getCompoundV3CometLens,
} from '../addresses/compoundV3'
import { Call } from '../../../utils/multicall'

export const buildCompoundV3StyleLenderReserveCall = (
  chainId: string,
  lender: string,
) => {
  const baseAssetData = getCompoundV3BaseAsset(lender, chainId)
  const underlyingArray = getCompoundV3Assets(chainId, lender)
  const cometContractAddress = getCompoundV3CometAddress(chainId, lender)!
  const assetsToQuery = underlyingArray
  const tokensNoBase = assetsToQuery.filter(
    (a) => a !== baseAssetData.baseAsset,
  )

  const callsAssetInfoAndTotals: Call[] = tokensNoBase.flatMap((tk) => {
    return [
      {
        address: cometContractAddress,
        name: 'getAssetInfoByAddress',
        params: [tk],
      },
      {
        address: cometContractAddress,
        name: 'totalsCollateral',
        params: [tk],
      },
    ]
  })

  const callSupplyRewards: Call = {
    address: cometContractAddress,
    name: 'baseTrackingSupplySpeed',
    params: [],
  }

  const callBorrowRewards: Call = {
    address: cometContractAddress,
    name: 'baseTrackingBorrowSpeed',
    params: [],
  }

  const callIndexScale: Call = {
    address: cometContractAddress,
    name: 'baseIndexScale',
    params: [],
  }

  const callSupply: Call = {
    address: cometContractAddress,
    name: 'totalSupply',
    params: [],
  }

  const callBorrow: Call = {
    address: cometContractAddress,
    name: 'totalBorrow',
    params: [],
  }

  const callInterest: Call = {
    address: getCompoundV3CometLens(chainId),
    name: 'getCometInterest',
    params: [cometContractAddress],
  }

  // Comet-level store-front price factor (WAD). Combined with each asset's
  // per-asset liquidationFactor to derive the liquidator discount / penalty.
  const callStoreFrontPriceFactor: Call = {
    address: cometContractAddress,
    name: 'storeFrontPriceFactor',
    params: [],
  }
  // Minimum borrow size, in BASE-asset units. Comet rejects any borrow that
  // would leave a position below this, so it is a hard gate on opening — not
  // a soft recommendation — and it is invisible without this read.
  const callBaseBorrowMin: Call = {
    address: cometContractAddress,
    name: 'baseBorrowMin',
    params: [],
  }
  const calls = [
    ...callsAssetInfoAndTotals,
    callSupplyRewards,
    callBorrowRewards,
    callIndexScale, // rewards data
    callSupply,
    callBorrow, // supply / borrow
    callInterest,
    callStoreFrontPriceFactor,
    callBaseBorrowMin,
  ]
  return calls
}
